namespace SP {
    export interface UpdatedRefund {
        confirmed: boolean;
        refundId: string;
        refundType: RefundType;
        refundFee: number;
        comment: string;
        lines: UpdatedRefundLine[];
    }

    export interface UpdatedRefundLine {
        refundId: string;
        refundLineId: string;
        price: number;
    }
}